import { useEffect, useState } from "react";
import { fetchPartner, fetchPartners } from "../api/fetchPartner";

function usePartner() {
    const [partner, setPartner] = useState<{ id: string, name: string } | undefined>(undefined);
    const [partners, setPartners] = useState<{ id: string, name: string }[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        getPartners();
    }, []);

    const getPartner = async (id: string) => {
        setLoading(true);
        const data = await fetchPartner(id!);
        setPartner(data);
        setLoading(false);
    }

    const getPartners = async () => {
        setLoading(true);
        const data = await fetchPartners();
        setPartners(data);
        setLoading(false);
    }

    return { partner, partners, loading, getPartner, getPartners };
}

export default usePartner;